import { MESES_ABREVIADOS } from "../../../constants/meses";

export function getScheduleDateParts(diaAgendado?: string) {
  if (!diaAgendado) return { month: "", day: "" };

  const [, month, day] = diaAgendado.split("-");
  const monthIndex = Number(month) - 1;

  return {
    month: MESES_ABREVIADOS[monthIndex] || "",
    day,
  };
}
